(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-real-reviews-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-carousel-track]');
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-item]'));
      var prevBtn = root.querySelector('[data-carousel-prev]');
      var nextBtn = root.querySelector('[data-carousel-next]');
      var dotsWrap = root.parentElement.querySelector('[data-carousel-dots]');
      if (!track || items.length === 0) return;

      function getPerView() {
        var w = window.innerWidth;
        if (w <= 640) return 1;
        if (w <= 989) return 2;
        return 3;
      }

      var perView = getPerView();
      var pageCount = Math.max(1, Math.ceil(items.length / perView));
      var index = 0;

      function renderDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        for (var i = 0; i < pageCount; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', 'Go to review page ' + (i + 1));
          dot.setAttribute('aria-current', i === index ? 'true' : 'false');
          (function (pageIndex) {
            dot.addEventListener('click', function () { goTo(pageIndex); });
          })(i);
          dotsWrap.appendChild(dot);
        }
      }

      function update() {
        var itemWidth = items[0].getBoundingClientRect().width;
        var gap = parseFloat(getComputedStyle(track).gap || 0);
        var offset = index * perView * (itemWidth + gap);
        track.style.transform = 'translateX(-' + offset + 'px)';
        if (prevBtn) prevBtn.disabled = index === 0;
        if (nextBtn) nextBtn.disabled = index >= pageCount - 1;
        if (dotsWrap) {
          Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
            dot.setAttribute('aria-current', i === index ? 'true' : 'false');
          });
        }
      }

      function goTo(newIndex) {
        index = Math.max(0, Math.min(pageCount - 1, newIndex));
        update();
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });

      window.addEventListener('resize', function () {
        var newPerView = getPerView();
        if (newPerView !== perView) {
          perView = newPerView;
          pageCount = Math.max(1, Math.ceil(items.length / perView));
          index = Math.min(index, pageCount - 1);
          renderDots();
        }
        update();
      });

      renderDots();
      update();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
